import { useEffect, useMemo, useState } from 'react';
import { usePipelineBoardSettings } from '../../pipelineBoardSettings/usePipelineBoardSettings';
import { usePropertyDefinitions } from 'crm-object-board-core/properties';
import { isValidAmountAggregationConfig } from 'crm-pipeline-board-settings-lib/aggregations/amount/amountConfig';
import { AmountAggregationCreator } from '../aggregators/amount/AmountAggregationCreator';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EMPTY = [];
const EMPTY_AGGREGATORS = [];

// Responsible for creating each aggregation
export const CreateAggregators = ({
  aggregatorsReady
}) => {
  const pipelineSettings = usePipelineBoardSettings();
  const propertyDefs = usePropertyDefinitions();
  //this is the only place that cannot use PropertyDefintions directly
  //we need to map :( but should only do it for this aggregator stuff
  const properties = useMemo(() => new Map(Array.from(propertyDefs).map(kvp => {
    return [kvp[0], kvp[1].property];
  })), [propertyDefs]);
  const aggregationConfigs = pipelineSettings && pipelineSettings.aggregations || EMPTY;
  const [configuredAggregators, setConfiguredAggregators] = useState([]);
  const aggregators = useMemo(() => {
    if (aggregationConfigs.length === 0) {
      return EMPTY_AGGREGATORS;
    }
    const isAggregator = agg => !!agg;
    const foundAggregators = configuredAggregators.filter(isAggregator);
    //only return when all aggregators are found that match the configs length
    //this means if one config never loads then no aggregations show
    if (foundAggregators.length === aggregationConfigs.length) {
      return foundAggregators;
    }
    return EMPTY_AGGREGATORS;
  }, [aggregationConfigs, configuredAggregators]);
  useEffect(() => {
    aggregatorsReady(aggregators);
  }, [aggregators, aggregatorsReady]);
  const handleAggregatorCreation = (index, aggregator) => {
    //only update state if new reference
    //should be memoized in creator
    if (configuredAggregators[index] !== aggregator) {
      configuredAggregators[index] = aggregator;
      setConfiguredAggregators([...configuredAggregators]);
    }
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: aggregationConfigs.map((config, i) => {
      if (config && isValidAmountAggregationConfig(properties, config)) {
        return /*#__PURE__*/_jsx(AmountAggregationCreator, {
          created: handleAggregatorCreation,
          config: config,
          index: i
        }, `${config.property}-${config.aggregation}-${i}`);
      }
      return null;
    })
  });
};